import React from "react";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";

export default function Home() {
  return (
    <>
      <Navbar />
      
      <section className="hero">
        <div className="container hero-content">
          <div className="hero-text">
            <h1>Gerçek Zamanlı Çok Dilli Konuşma Çevirisi</h1>
            <p>
              Canlı konuşmayı yakalayın, anında birden fazla dile çevirin ve metin veya ses olarak katılımcılara dünyanın her yerinden iletin.
            </p>
            <div className="cta-buttons">
              <a href="#demo" className="cta primary">Demo Talep Et</a>
              <a href="#trial" className="cta secondary">Hemen Dene</a>
            </div>
          </div>
          {/*<div className="hero-image">
            <img 
              src="https://via.placeholder.com/500x350" 
              alt="TercumanApp canlı çeviri uygulaması" 
            />
          </div> */}
        </div>
      </section>
      
      <section id="how-it-works">
        <div className="container">
          <div className="section-header">
            <h2>Nasıl Çalışır?</h2>
            <p>Tercüman App, etkinlikleriniz için çok dilli anlık çeviri sürecini kolaylaştırır</p>
          </div>
          
          <div className="steps">
            <div className="step-item">
              <div className="step-number">1</div>
              <h3>Yayın</h3>
              <p>Teknisyen, web tabanlı kontrol panelinden canlı ses yayını yapar</p>
            </div>
            
            <div className="step-item">
              <div className="step-number">2</div>
              <h3>İşleme</h3>
              <p>Altyapımız konuşmayı yazıya döker, dili algılar, çevirir ve sese dönüştürür</p>
            </div>
            
            <div className="step-item">
              <div className="step-number">3</div>
              <h3>Erişim</h3>
              <p>Katılımcılar tercih ettikleri dilde gerçek zamanlı metin ve sese erişir</p>
            </div>
          </div>
        </div>
      </section>
      
      <section id="features">
        <div className="container">
          <div className="section-header">
            <h2>Öne Çıkan Özellikler</h2>
            <p>Modern teknoloji ile desteklenen ve etkinliklerinizi dönüştüren özellikler</p>
          </div>
          
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🎤</div>
              <h3>Sürekli Konuşma Tanıma</h3>
              <p>Gerçek zamanlı konuşma tanıma ve dil algılama teknolojisi</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">🌍</div>
              <h3>Çoklu Dil Desteği</h3>
              <p>Konuşmaları anında birden fazla dile çevirme</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">🔊</div>
              <h3>Ses Sentezi</h3>
              <p>Çevirileri doğal sesli anlatım olarak dinleme imkanı</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">🔒</div>
              <h3>Güvenli Erişim</h3>
              <p>Oturum kodları ile katılımcı erişiminin güvenle sağlanması</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">⚙️</div>
              <h3>Kolay Yönetim</h3>
              <p>Web tabanlı teknisyen kontrol paneli ile kolay kullanım</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3>Ölçeklenebilir</h3>
              <p>Binlerce katılımcıya aynı anda hizmet verebilme kapasitesi</p>
            </div>
          </div>
        </div>
      </section>
      
      <section id="use-cases" className="use-cases">
        <div className="container">
          <div className="section-header">
            <h2>Kullanım Alanları</h2>
            <p>TercumanApp'in farklı senaryolarda nasıl değer kattığını keşfedin</p>
          </div>
          
          <div className="use-cases-grid">
            <div className="use-case-card">
              <h3>Kurumsal Etkinlikler</h3>
              <p>Çok uluslu şirketler için global toplantılar ve etkinlikler</p>
            </div>
            
            <div className="use-case-card">
              <h3>Uluslararası Konferanslar</h3>
              <p>Farklı ülkelerden katılımcıların olduğu bilimsel ve akademik konferanslar</p>
            </div>
            
            <div className="use-case-card">
              <h3>Canlı Yayınlar</h3>
              <p>Canlı yayınlanan panel ve söyleşiler için anlık çeviri</p>
            </div>
            
            <div className="use-case-card">
              <h3>Kamu ve STK Toplantıları</h3>
              <p>Hükümet kurumları ve sivil toplum kuruluşlarının çok dilli toplantıları</p>
            </div>
          </div>
        </div>
      </section>
      
      <section id="testimonials">
        <div className="container">
          <div className="section-header">
            <h2>Müşteri Yorumları</h2>
            <p>TercumanApp'i kullananlar ne diyor?</p>
          </div>
          
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <p className="quote">"TercumanApp, çok dilli konferanslarımızı yönetmemizi kolaylaştırdı ve katılımcı memnuniyetini önemli ölçüde artırdı."</p>
              <div className="author">
                <div className="author-avatar"></div>
                <div>
                  <div className="author-name">Ayşe Yılmaz</div>
                  <div className="author-title">Etkinlik Koordinatörü, GlobeConf</div>
                </div>
              </div>
            </div>
            
            <div className="testimonial-card">
              <p className="quote">"Güçlü altyapısı ve gerçek zamanlı çeviri özellikleriyle, uluslararası müşterilerimizle iletişimi hiç olmadığı kadar kolay hale getirdi."</p>
              <div className="author">
                <div className="author-avatar"></div>
                <div>
                  <div className="author-name">Mehmet Kaya</div>
                  <div className="author-title">CTO, TechGlobal Inc.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <section className="cta-section">
        <div className="container">
          <h2>Etkinliklerinizi Küreselleştirmeye Hazır Mısınız?</h2>
          <p>TercumanApp ile dil bariyerlerini aşın ve tüm dünyaya ulaşın.</p>
          <div className="cta-buttons">
            <a href="#demo" className="cta primary">Demo Talep Et</a>
            <a href="#contact" className="cta secondary">İletişime Geç</a>
          </div>
        </div>
      </section>
      
      <section id="contact">
        <div className="container">
          <div className="section-header">
            <h2>İletişim</h2>
            <p>Sorularınız için bizimle iletişime geçin</p>
          </div>
          
          <div className="contact-details">
            <div className="contact-info">
              <div className="contact-item">
                <div className="contact-icon">📧</div>
                <h3>E-posta</h3>
                <p><a href="mailto:info@tercuman.app">info@tercuman.app</a></p>
              </div>
              
              <div className="contact-item">
                <div className="contact-icon">📍</div>
                <h3>Adres</h3>
                <p>İstanbul, Türkiye</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
